// timeline slider about us page
if ($(".timeline-frame").length) {
$(".timeline-frame").slick({
  slidesToShow: 2.1,
  slidesToScroll: 1,
  // centerMode: true,
  arrows: false,
  infinite: false,
  draggable: true, // Removed asNavFor to stop linking sliders
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
}

if ($(".timeline-nav").length) {
$(".timeline-nav").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: ".timeline-frame", // Keeps .timeline-nav controlling .timeline-frame
  // centerMode: true,
  dots: false,
  infinite: false,
  focusOnSelect: true,
  draggable: true,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        arrows: false,
        // centerMode: true,
      },
    },
  ],
});
}

// marquee slider

if ($(".marquee-slider-img").length) {
$(".marquee-slider-img").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 10000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  // rtl: true,

  responsive: [
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
      },
    },

    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        speed: 7000,
        cssEase: "linear",
      },
    },
  ],
});
}

// slider to right

if ($(".marquee-slider-rtl").length) {
$(".marquee-slider-rtl").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 10000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  rtl: true,

  responsive: [
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
      },
    },

    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        speed: 7000,
        cssEase: "linear",
      },
    },
  ],
});
}

// mobile slick slider with dots

$(document).ready(function () {
  // Check for mobile screens (<=768px)
  if ($(window).width() <= 768) {
    $(".slick-slider-enable").slick({
      autoplay: false,
      dots: true,
      arrows: false,
      customPaging: function (slider, i) {
        return '<span class="dot"></span>'; // Customize the dots
      },
    });
  }

  // Reinitialize Slick on window resize
  $(window).resize(function () {
    if ($(window).width() <= 768) {
      if (!$(".slick-slider-enable").hasClass("slick-initialized")) {
        $(".slick-slider-enable").slick({
          autoplay: false,
          dots: true,
          arrows: false,
          customPaging: function (slider, i) {
            return '<span class="dot"></span>'; // Customize the dots
          },
        });
      }
    } else {
      if ($(".slick-slider-enable").hasClass("slick-initialized")) {
        $(".slick-slider-enable").slick("unslick");
      }
    }
  });
});

if ($(".bog_slider").length) {
var swiper = new Swiper(".bog_slider", {
  slidesPerView: 5.2,
  spaceBetween: 0,
  freeMode: true,
  freeModeMomentum: false,
  slidesOffsetAfter: 0,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  // autoplay: {
  //     delay: 1000,
  //     pauseOnMouseEnter: true,
  //     disableOnInteraction: false,
  // },
  breakpoints: {
    1249: {
      slidesPerView: 5.2,
      // spaceBetween: 15,
    },

    989: {
      slidesPerView: 4.2,
      // spaceBetween: 15,
    },
    768: {
      slidesPerView: 2.2,
      spaceBetween: 0,
    },

    320: {
      slidesPerView: 1.2,
      spaceBetween: 0,
    },
  },
});
}

if ($(".pdt2_slider").length) {
$(".pdt2_slider").slick({
  // centerMode: true,
  centerPadding: "60px",
  arrows: true,
  slidesToShow: 3,
  prevArrow: `
    <button class="slick-prev" aria-label="Previous" type="button">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g id="Group_2295" data-name="Group 2295" transform="translate(-1047 -527)">
          <g id="Ellipse_21" data-name="Ellipse 21" transform="translate(1047 527)" fill="#f4f4f4" stroke="#babab8" stroke-width="1">
            <circle cx="30" cy="30" r="30" stroke="none"/>
            <circle cx="30" cy="30" r="29.5" fill="none"/>
          </g>
          <g id="right-arrow_1_" data-name="right-arrow (1)" transform="translate(1064.5 551.167)">
            <g id="Group_263" data-name="Group 263">
              <path id="Path_12" data-name="Path 12" d="M24.046,137.219h0l-4.965-4.941a.95.95,0,1,0-1.341,1.347l3.333,3.317H.95a.95.95,0,1,0,0,1.9H21.073l-3.333,3.317a.95.95,0,0,0,1.341,1.347l4.965-4.941h0A.951.951,0,0,0,24.046,137.219Z" transform="translate(0 -132)" fill="#8a6347"/>
            </g>
          </g>
        </g>
      </svg>
    </button>`,
  nextArrow: `
    <button class="slick-next" aria-label="Next" type="button">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g id="Group_2295" data-name="Group 2295" transform="translate(-1047 -527)">
          <g id="Ellipse_21" data-name="Ellipse 21" transform="translate(1047 527)" fill="#f4f4f4" stroke="#babab8" stroke-width="1">
            <circle cx="30" cy="30" r="30" stroke="none"/>
            <circle cx="30" cy="30" r="29.5" fill="none"/>
          </g>
          <g id="right-arrow_1_" data-name="right-arrow (1)" transform="translate(1064.5 551.167)">
            <g id="Group_263" data-name="Group 263">
              <path id="Path_12" data-name="Path 12" d="M24.046,137.219h0l-4.965-4.941a.95.95,0,1,0-1.341,1.347l3.333,3.317H.95a.95.95,0,1,0,0,1.9H21.073l-3.333,3.317a.95.95,0,0,0,1.341,1.347l4.965-4.941h0A.951.951,0,0,0,24.046,137.219Z" transform="translate(0 -132)" fill="#8a6347"/>
            </g>
          </g>
        </g>
      </svg>
    </button>`,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        // centerMode: true,
        dots: true,
        centerPadding: "40px",
        slidesToShow: 1,
        customPaging: function (slider, i) {
          return '<span class="dot"></span>'; // Customize the dots
        },
      },
    },
    // {
    //     breakpoint: 480,
    //     settings: {
    //         arrows: false,
    //         // centerMode: true,
    //         dots: true,
    //         centerPadding: "40px",
    //         slidesToShow: 4,
    //         customPaging: function (slider, i) {
    //             return '<span class="dot"></span>'; // Customize the dots
    //         },
    //     },
    // },
  ],
});
}

// if ($(window).width() < 991) {
//     var $swiperSelector = $(".swiper-custom-container");

//     $swiperSelector.each(function (index) {
//         var $this = $(this);
//         $this.addClass("swiper-slider-" + index);

//         // var dragSize = $this.data("drag-size") ? $this.data("drag-size") : auto;
//         var freeMode = $this.data("free-mode") ? $this.data("free-mode") : false;
//         var loop = $this.data("loop") ? $this.data("loop") : false;
//         var slidesDesktop = $this.data("slides-desktop") ? $this.data("slides-desktop") : 4;
//         var slidesTablet = $this.data("slides-tablet") ? $this.data("slides-tablet") : 4;
//         var slidesMobile = $this.data("slides-mobile") ? $this.data("slides-mobile") : 2.5;
//         var spaceBetween = $this.data("space-between") ? $this.data("space-between") : 20;

//         var swiper = new Swiper(".swiper-slider-" + index, {
//             direction: "horizontal",
//             loop: loop,
//             // freeMode: freeMode,
//             // spaceBetween: spaceBetween,
//             // spaceBetween: 30,
//             breakpoints: {
//                 992: {
//                     slidesPerView: 12,
//                 },
//                 320: {
//                     slidesPerView: 2,
//                 },
//             },
//             navigation: {
//                 nextEl: ".swiper-button-next",
//                 prevEl: ".swiper-button-prev",
//             },
//             scrollbar: {
//                 el: ".swiper-scrollbar",
//                 draggable: true,
//                 dragSize: "auto",
//             },
//         });
//     });
// }

if (document.querySelector(".feature_coll_swiper")) {
var swiper = new Swiper(".feature_coll_swiper", {
  slidesPerView: 4.2,
  spaceBetween: 0,
  freeMode: true,
  freeModeMomentum: false,
  slidesOffsetAfter: 0,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: false,
    draggable: true,
  },
  // autoplay: {
  //     delay: 1000,
  //     pauseOnMouseEnter: true,
  //     disableOnInteraction: false,
  // },
  breakpoints: {
    1249: {
      slidesPerView: 4.6,
      // spaceBetween: 15,
    },

    989: {
      slidesPerView: 3.6,
      // spaceBetween: 15,
    },
    768: {
      slidesPerView: 3.6,
      // spaceBetween: 15,
    },
    550: {
      slidesPerView: 2.5,
      // spaceBetween: 15,
    },

    320: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
  },
});
}